(function () {
  if (window.__wishlistInit) return;
  window.__wishlistInit = true;

  var KEY = 'shopify_wishlist';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function isSaved(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle, btn) {
    var list = getList();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveList(list);
    refreshButton(btn, handle);
    updateNavBadge();
  }

  function refreshButton(btn, handle) {
    if (isSaved(handle)) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }
  }

  function updateNavBadge() {
    var badge = document.getElementById('wishlistNavCount');
    if (!badge) return;
    var count = getList().length;
    badge.textContent = count;
    if (count > 0) {
      badge.removeAttribute('hidden');
    } else {
      badge.setAttribute('hidden', 'hidden');
    }
  }

  function init() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-btn');
      refreshButton(btn, handle);
    });
    updateNavBadge();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-btn');
    toggle(handle, btn);
  });

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  window.getWishlist = getList;
})();